// Extracted from the main translation file to keep it under the file-length cap.
export const enGenerateBar = {
	frameworks: {
		title: "✨ Choose Frameworks",
		step1: "Message 1 — Initial",
		step2: "Message 2 — Follow-up 1",
		step3: "Message 3 — Follow-up 2",
		autoSuggest: "Auto-suggest",
		autoSuggestDescription: "Let the Framework Strategy Agent decide",
		save: "Save frameworks",
		cancel: "Cancel",
	},
	effectiveness: {
		heading: "Top performing",
		ariaLabel: "Top performing frameworks based on historical reply rate",
		scopePersonaCompany: "for this persona × company category",
		scopeCompany: "for this company category",
	},
	signalChip: {
		label: "Signal",
		ariaLabel: "Selected signal used as the outreach trigger",
		remove: "Remove signal — write without it",
	},
	pinnedFacts: {
		label_one: "{{count}} research fact will be mentioned",
		label_other: "{{count}} research facts will be mentioned",
		remove: "Don't mention this fact",
	},
	senderSelect: {
		chooseSender: "Choose sender",
		connectedTo: "Connected to {{name}} on LinkedIn",
		notConnectedTo: "Not connected to {{name}}",
		// Their own invitation to the lead is still pending (PREC-4216).
		invitationPendingTo: "Invitation to {{name}} pending",
		tooltip: "Sender: {{name}}",
		// Why a sender cannot be chosen for this lead, or a warning on one who can (PREC-4244).
		notes: {
			linkedinDisconnected:
				"LinkedIn disconnected, reconnect under Personal settings → Connected Accounts",
			nothingConnected:
				"Connect a mailbox or LinkedIn under Personal settings → Connected Accounts",
			noEmailForLead: "No email address for this lead",
			noLinkedinForLead: "No LinkedIn profile for this lead",
			noChannelForLead: "No email address or LinkedIn profile for this lead",
		},
	},
	channelSelect: {
		email: "Email",
		linkedin: "LinkedIn",
		tooltip: "Channel: {{channel}}",
	},
	languageSelect: {
		autoDetect: "Auto-detect",
		autoShort: "Auto",
		searchLanguage: "Search language...",
		configureRules: "Configure auto-detect rules…",
		tooltip: "Language: {{language}}",
	},
	collapsedLabel: "Tell AI what to write",
	inviteNoteAlreadyConnected:
		"{{sender}} is already connected to {{prospect}} on LinkedIn. The invite note only applies when sending a connection request.",
	inviteNoteInvitationPending:
		"{{sender}}'s invitation to {{prospect}} is still pending, so no second invitation is sent. The messages wait until {{prospect}} accepts.",
	inviteNoteFreeQuota:
		"{{sender}} is on LinkedIn Free. LinkedIn lets a Free account add a note to only a few connection requests a month, of at most 200 characters, so the note starts switched off.",
	// Queued / running / failed states of a draft generation (PREC-4052).
	status: {
		queued: "Queued · {{elapsed}}",
		generating: "Generating…",
		preparing: "Preparing generation...",
		elapsed: "{{label}} · {{elapsed}}",
		slowQueued: "Taking longer than usual: still waiting for a free slot.",
		slowRunning: "Taking longer than usual: still writing.",
		alreadyInProgress: "Generation already in progress — waiting for current run to finish.",
		freshStart: "Fresh start — ignore prior outreach",
		failedAbove: "The last generation failed: {{error}}",
		failedAboveHint: "Open “Tell AI what to write” below to try again.",
		tryAgain: "Try again",
		notEnoughCredits:
			"Not enough credits to write drafts. Add credits under Company Settings → Plans & Billing.",
		buttonQueued: "Queued",
	},
};
